import './style.css'

import Experience from './Experience/Experience.js'
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const id = urlParams.get('id')
if(id == "")
    id = 0;

const experience = new Experience(document.querySelector('canvas.webgl'), id)
/*import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import gsap from 'gsap'

//Base

// Debug

// Canvas
const canvas = document.querySelector('canvas.webgl')
const leftButton = document.getElementById("left")
leftButton.addEventListener("click", leftCamera,false)
const rightButton = document.getElementById("right")
rightButton.addEventListener("click", rightCamera,false)
const segmentButton1 = document.querySelector('.segment-1')
const segmentButton2 = document.querySelector('.segment-2')
const segmentButton3 = document.querySelector('.segment-3')
const segmentButton4 = document.querySelector('.segment-4')
const segmentButton5 = document.querySelector('.segment-5')
const segmentButton6 = document.querySelector('.segment-6')
const helpImg = document.querySelector('.rotation')
const footerTxt = document.querySelector('.foot')
const segmentLabel1 = document.querySelector('.label-1')
const segmentLabel2 = document.querySelector('.label-2')
const segmentLabel3 = document.querySelector('.label-3')
const segmentLabel4 = document.querySelector('.label-4')
const segmentLabel5 = document.querySelector('.label-5')
const segmentLabel6 = document.querySelector('.label-6')
const mainIcon = document.querySelector('.main')
const secondIcon = document.querySelector('.second')

var screenHelpPosition;
var translateX;
var translateY;
// Scene
const scene = new THREE.Scene()

/// Models

const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('./draco/')

const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)
///Texture loader

const textureLoader = new THREE.TextureLoader()

///Variables 

const islandCount = 6
const increment = 20
const angleIncrement = -Math.PI/4
const startAngle = Math.PI
const islandRatio = 30
const amplitude = 0.3
const period = 1
const localPanLimit = 3;
var island1
var island2
var island3
var island4
var island5
var island6
const islands = new Array(islandCount)
const clouds = new Array(islandCount)
var cloud 
var curIndex = 0
const cameraOffset = 30;
const cameraYOffset = 8;
const cameraInitialOffset = 60;
const cameraLinearOffset = new THREE.Vector3(0,-4,22);
var startTime;
const mouse = new THREE.Vector2()
const raycaster = new THREE.Raycaster()
let currentIntersect = null
const labelOffset= 12;
var firstInteraction = true;

//Textures
const islandTexture = textureLoader.load('./models/Environment/Isla_InstAereav2Bake.jpg')
islandTexture.flipY = false
const islandSubTexture = textureLoader.load('./models/Environment/Isla_InstSubv2Bake.jpg')
islandSubTexture.flipY = false
islandSubTexture.anisotropy = 4;
const cloudsTexture = textureLoader.load('./models/Environment/CloudBake1024.jpg')
cloudsTexture.flipY = false
const island3Tex = textureLoader.load('./models/Environment/Isla_InstUMillav2.jpg')
island3Tex.flipY = false
const island4Tex = textureLoader.load('./models/Environment/Isla_InstCDatosV2Bake.jpg')
island4Tex.flipY = false
const island5Tex = textureLoader.load('./models/Environment/Isla_InstCEstrucv2Bake.jpg')
island5Tex.flipY = false
const island6Tex = textureLoader.load('./models/Environment/Isla_FIB2Uv2Bake.jpg')
island6Tex.flipY = false

//Materials
const islandMaterial = new THREE.MeshBasicMaterial({map: islandTexture})
const islandSubMaterial = new THREE.MeshBasicMaterial({map: islandSubTexture})
const cloudsMaterial = new THREE.MeshBasicMaterial({map: cloudsTexture})
const island3Material = new THREE.MeshBasicMaterial({map: island3Tex})
const island4Material = new THREE.MeshBasicMaterial({map: island4Tex})
const island5Material = new THREE.MeshBasicMaterial({map: island5Tex})
const island6Material = new THREE.MeshBasicMaterial({map: island6Tex})
//animations
let mixer = null
var controlPos
var targetControlPos 
var targetCamPos 
var initialControlPos
 
 var screenType;
 if((window.innerWidth / window.innerHeight) < 1.3)
 {    screenType =  2;
    
        segmentLabel1.classList.add('invisible');
        segmentLabel2.classList.add('invisible');
        segmentLabel3.classList.add('invisible');
        segmentLabel4.classList.add('invisible');
        segmentLabel5.classList.add('invisible');
        segmentLabel6.classList.add('invisible');
        firstInteraction = false;
    
 }
 else if((window.innerWidth / window.innerHeight) < 1.45)
    screenType =  1;
 else
    screenType =  0;

//Sizes

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
///Camera
// Base camera
const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 1000)
if(screenType == 0)
    camera.position.set(CalcCamLinearInitialPos().x, CalcCamLinearInitialPos().y, CalcCamLinearInitialPos().z)
else if(screenType == 1)
    camera.position.set(CalcCamLinearInitialPos().x, CalcCamLinearInitialPos().y, CalcCamLinearInitialPos().z+15)
else
    camera.position.set(CalcCamLinearPos(0).x, CalcCamLinearPos(0).y, CalcCamLinearPos(0).z)
camera.lookAt( CalcLinearPos(curIndex) )
scene.add(camera)

gltfLoader.load(
    './models/Environment/Isla_InstAereav2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = islandMaterial
        })
        island1 = gltf.scene     
        islands[0] = island1.clone(true);      
        islands[0].position.x = CalcLinearPos(0).x
        islands[0].position.z = CalcLinearPos(0).z     
        scene.add(islands[0])        
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Isla_InstSubv2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = islandSubMaterial
        })
        island2 = gltf.scene    
           islands[1] = island2.clone(true);
        
             islands[1].position.x = CalcLinearPos(1).x
             islands[1].position.z = CalcLinearPos(1).z           
      
           scene.add(islands[1])
        
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Isla_InstUMillav2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = island3Material
        })
        console.log(gltf)
        island3 = gltf.scene        
        islands[2] = island3.clone(true);           
        islands[2].position.x = CalcLinearPos(2).x
        islands[2].position.z = CalcLinearPos(2).z           
        scene.add(islands[2])
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Isla_InstCDatosv2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = island4Material
        })
        island4 = gltf.scene
        islands[3] = island4.clone(true);
        islands[3].position.x = CalcLinearPos(3).x
        islands[3].position.z = CalcLinearPos(3).z           
        scene.add(islands[3])
        
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Isla_InstCEstrucv2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = island5Material
        })
        island5 = gltf.scene
        islands[4] = island5.clone(true)       
        islands[4].position.x = CalcLinearPos(4).x
        islands[4].position.z = CalcLinearPos(4).z           
        scene.add(islands[4])
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Isla_FIB2Uv2.glb',
    (gltf) =>
    {
        console.log('success')        
        gltf.scene.traverse((child)=>
        {
            child.material = island6Material
        })
        island6 = gltf.scene
        islands[5] = island6.clone(true);        
        islands[5].position.x = CalcLinearPos(5).x
        islands[5].position.z = CalcLinearPos(5).z                   
        scene.add(islands[5])        
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    './models/Environment/Clouds.glb',
    (gltf) =>
    {
        console.log('success')
        gltf.scene.traverse((child)=>
        {
            child.material = cloudsMaterial
        })
        cloud = gltf.scene
        for(var i = 0; i < 2;i++)
        {
            clouds[i] = cloud.clone(true);           
            
            clouds[i].position.x = CalcLinearPos(i).x;  
            clouds[i].position.z = CalcLinearPos(i).z;  
            clouds[i].rotateY( (Math.PI / islandCount) * i)
            scene.add(clouds[i])
        }
        
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)

///Lights
 
const ambientLight = new THREE.AmbientLight(0xffffff, 0.8)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(- 5, 5, 0)
scene.add(directionalLight)

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

window.addEventListener('pointerdown',(event) =>
{    
    startTime = clock.getElapsedTime()
    if(firstInteraction)
    {
        segmentLabel1.classList.add('invisible');
        segmentLabel2.classList.add('invisible');
        segmentLabel3.classList.add('invisible');
        segmentLabel4.classList.add('invisible');
        segmentLabel5.classList.add('invisible');
        segmentLabel6.classList.add('invisible');
        firstInteraction = false;
    }
    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = -(event.clientY / sizes.height)* 2 + 1;
})
window.addEventListener('pointerup', () =>
{
    const deltaTimeMouse = clock.getElapsedTime() - startTime
    
    if(deltaTimeMouse < 0.2)
    {
    if(currentIntersect)    
    {
        //console.log("name ".concat(currentIntersect.object.name))
        
        switch(currentIntersect.object.name)  
        {
            case "Isla_InstAerea":
            case"Isla_InstAereav2":
            case "Insla_InstaAerea":
                curIndex = 0
                break
            case "Isla_InstaSub":
            case "Isla_InstSubv2":
                curIndex = 1
                break
            case "Isla_InstUMilla":
            case "Isla_InstUMillav2":
                curIndex = 2
                break
            case "Isla_InstCDatos":
            case "Isla_InstCDatosv2":
                curIndex = 3
                break
            case "Isla_InstCEstruc":
            case "Isla_InstCEstrucv2":
                curIndex = 4
                break
            case "Isla_FIB2Uv2":
                curIndex = 5
                break                
        }
        
        if(curIndex != clickType)
        {
            clickType = curIndex;
            mainIcon.classList.add('invisible')
            secondIcon.classList.add('visible')
            LerpCamera()           
            ManageSegmentButtons() 
        }
    }
    }
})





if(screenType == 2)
{
    leftButton.classList.add('visible')       
    rightButton.classList.add('visible')   
}

// Controls
const controls = new OrbitControls(camera, canvas)

if(screenType  == 2)
controls.target.set(CalcLinearPos(0).x, CalcLinearPos(0).y, CalcLinearPos(0).z)
else
controls.target.set(CalcLinearInitialPos().x, CalcLinearInitialPos().y, CalcLinearInitialPos().z)

controls.enableDamping = true
controls.maxZoom = 110
controls.minZoom = 8
controls.maxDistance = 110
controls.minDistance = 8

var minPan = new THREE.Vector3( 40, - 15, - 30 );
var maxPan = new THREE.Vector3( 55, 15, 30 );
var _v = new THREE.Vector3();

controls.addEventListener("change", function() {
    //console.log(clock.getElapsedTime());
    _v.copy(controls.target);
    controls.target.clamp(minPan, maxPan);
    _v.sub(controls.target);
    camera.position.sub(_v);
    if(firstInteraction && (clock.getElapsedTime()>0.01))
    {
        segmentLabel1.classList.add('invisible');
        segmentLabel2.classList.add('invisible');
        segmentLabel3.classList.add('invisible');
        segmentLabel4.classList.add('invisible');
        segmentLabel5.classList.add('invisible');
        segmentLabel6.classList.add('invisible');
        firstInteraction = false;
    }
})

//console.log(controls.zoom);
if(screenType==2)
ManageSegmentButtons();

curIndex = 0;
if(screenType == 2)
LerpCamera();
//LerpCamera();
//else

///Renderer

var clickType = -1;
  const renderer = new THREE.WebGLRenderer({
    canvas: canvas, alpha:true, antialias:true
  });

renderer.setClearColor(0x000000, 1)
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const loader = new THREE.TextureLoader();
const bgTexture = loader.load('./images/bgGradient.png');
scene.background = bgTexture;


const clock = new THREE.Clock()
let previousTime = 0
const helpPoint = new THREE.Vector3(-3,5,0);


var timeToHelp = {t:0};
 gsap.to(timeToHelp, {       
    t:3,                 
    duration: 5,        
    onComplete: function() 
    {
        helpImg.classList.add('invisible')
    }
}).play();

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime
    
    //animation
    if(clouds.length > 0)
    {
        for(var i = 0; i < islandCount;i++)
        {
            cloud = clouds[i]
            if(cloud)
                cloud.rotation.y += deltaTime *.03
            island1 = islands[i]
            if(island1)
                island1.position.y = amplitude * Math.cos(elapsedTime*period)
        }
    }
    // Cast a ray from the mouse and handle events
    raycaster.setFromCamera(mouse, camera)
   
    const intersects = raycaster.intersectObjects(scene.children, true)
    
    if(intersects.length)
    {
        currentIntersect = intersects[0]
    }
    else
    {
        currentIntersect = null
    }
        
     controls.update();
     
     if(firstInteraction)
     {
        if(islands[0] != null)
        {
            screenHelpPosition = islands[0].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel1.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
        if(islands[1] != null)
        {
            screenHelpPosition = islands[1].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel2.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
        if(islands[2] != null)
        {
            screenHelpPosition = islands[2].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel3.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
        if(islands[3] != null)
        {
            screenHelpPosition = islands[3].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel4.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
        if(islands[4] != null)
        {
            screenHelpPosition = islands[4].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel5.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
        if(islands[5] != null)
        {
            screenHelpPosition = islands[5].position.clone()
            screenHelpPosition.y -= labelOffset;
            screenHelpPosition.project(camera)
            translateX = screenHelpPosition.x * sizes.width * 0.5 - 50
            translateY = -screenHelpPosition.y * sizes.height * 0.5 -50
            segmentLabel6.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
    }
    // Render
    renderer.render(scene, camera)    
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

function leftCamera()
{    
    if(curIndex>0)    
        curIndex--  
    else
        curIndex = islandCount-1

    if(firstInteraction)
    {
        segmentLabel1.classList.add('invisible');
        segmentLabel2.classList.add('invisible');
        segmentLabel3.classList.add('invisible');
        segmentLabel4.classList.add('invisible');
        segmentLabel5.classList.add('invisible');
        segmentLabel6.classList.add('invisible');
        firstInteraction = false;
    }
    mainIcon.classList.add('invisible')
    secondIcon.classList.add('visible')
    LerpCamera()           
    ManageSegmentButtons()  
}
function rightCamera()
{    
    if(curIndex<islandCount-1)    
        curIndex++           
    else 
        curIndex = 0;
        if(firstInteraction)
        {
            segmentLabel1.classList.add('invisible');
            segmentLabel2.classList.add('invisible');
            segmentLabel3.classList.add('invisible');
            segmentLabel4.classList.add('invisible');
            segmentLabel5.classList.add('invisible');
            segmentLabel6.classList.add('invisible');
            firstInteraction = false;
        }
        mainIcon.classList.add('invisible')
        secondIcon.classList.add('visible')
    LerpCamera()           
    ManageSegmentButtons()
}

function CalcLinearPos(index)
{
    const position = new THREE.Vector3()
    position.x = increment*index
    position.y = 0
    position.z = 0
    return position
}
function CalcLinearInitialPos()
{
    const position = new THREE.Vector3()
    position.x = increment*2.5
    position.y = 0
    position.z = 0
    return position
}

function CalcCamLinearPos(index)
{
    const position = new THREE.Vector3()
    position.x = increment*index
    position.y = cameraLinearOffset.y;
    position.z = cameraLinearOffset.z;
    return position
}
function CalcCamLinearInitialPos()
{
    const position = new THREE.Vector3()
    position.x = increment*2.5
    position.y = cameraYOffset
    position.z = cameraInitialOffset;
    return position
}

function CalcPos(angle, ratio)
{
    const position = new THREE.Vector3()
    position.x = ratio*Math.cos(angle)
    position.y = 0
    position.z = ratio*Math.sin(angle)
    return position
}

function CalcCamPos(iterator)
{
    var newPos = new THREE.Vector3()
    const zero = new THREE.Vector3(0,0,0)
    var direction = new THREE.Vector3()
    newPos = CalcPos(startAngle +(iterator*angleIncrement), islandRatio)
    direction.subVectors( zero, newPos).normalize()
    var finalPos = new THREE.Vector3()
    finalPos.subVectors(newPos, direction.multiplyScalar(cameraOffset))
    return finalPos
}

function LerpCamera()
{
    controlPos = camera.position

        targetCamPos = CalcCamLinearPos(curIndex)
        targetControlPos = CalcLinearPos(curIndex)                          
    
    initialControlPos = controls.target
    minPan = new THREE.Vector3( -10, - 15, - 30 );
    maxPan = new THREE.Vector3( 110, 15, 30 );

    gsap.to(controlPos, {                        
            duration: 0.5,
            x: targetCamPos.x, y: targetCamPos.y + cameraYOffset, z: targetCamPos.z,
            onStart: function() {
                controls.enabled = false;
                },
            onUpdate: function() {
                camera.position.set(controlPos.x, controlPos.y, controlPos.z);
                },
            onComplete: function() {
                controls.enabled = true;
                }
    }).play();
    gsap.to(initialControlPos, {                        
        duration: 0.5,
        x: targetControlPos.x, y: targetControlPos.y, z: targetControlPos.z,
        onStart: function() {
            controls.enabled = false;
            },
        onUpdate: function() {                    
            camera.lookAt(initialControlPos)
            controls.update();
            },
        onComplete: function() {
            minPan = islands[curIndex].position.clone().sub( new THREE.Vector3(localPanLimit,localPanLimit,localPanLimit));
            maxPan = islands[curIndex].position.clone().add( new THREE.Vector3(localPanLimit,localPanLimit,localPanLimit));
            controls.maxZoom = 20
        controls.maxDistance = 20
            controls.enabled = true;
            }       
    }).play();
}

function ManageSegmentButtons()
{    
    switch(curIndex)
    {
        case 0:
            segmentButton1.classList.add('visible')       
            segmentButton2.classList.remove('visible')   
            segmentButton3.classList.remove('visible')       
            segmentButton4.classList.remove('visible')       
            segmentButton5.classList.remove('visible')       
            segmentButton6.classList.remove('visible')       
            break
        case 1:
            segmentButton1.classList.remove('visible')       
            segmentButton2.classList.add('visible')   
            segmentButton3.classList.remove('visible')  
            segmentButton4.classList.remove('visible')       
            segmentButton5.classList.remove('visible')       
            segmentButton6.classList.remove('visible')        
            break
        case 2:
            segmentButton1.classList.remove('visible')       
            segmentButton2.classList.remove('visible')   
            segmentButton3.classList.add('visible')
            segmentButton4.classList.remove('visible')       
            segmentButton5.classList.remove('visible')       
            segmentButton6.classList.remove('visible')          
            break
        case 3:
            segmentButton1.classList.remove('visible')       
            segmentButton2.classList.remove('visible')   
            segmentButton3.classList.remove('visible')
            segmentButton4.classList.add('visible')       
            segmentButton5.classList.remove('visible')       
            segmentButton6.classList.remove('visible')          
            break
        case 4:
            segmentButton1.classList.remove('visible')       
            segmentButton2.classList.remove('visible')   
            segmentButton3.classList.remove('visible')
            segmentButton4.classList.remove('visible')       
            segmentButton5.classList.add('visible')       
            segmentButton6.classList.remove('visible')          
            break
        case 5:
            segmentButton1.classList.remove('visible')       
            segmentButton2.classList.remove('visible')   
            segmentButton3.classList.remove('visible')
            segmentButton4.classList.remove('visible')       
            segmentButton5.classList.remove('visible')       
            segmentButton6.classList.add('visible')          
            break
    } 
    leftButton.classList.add('visible')       
    rightButton.classList.add('visible')
    footerTxt.classList.add('invisible');
}*/
